import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { Link } from "react-router-dom";

const TRANSLATIONS = {
  en: {
    title: "Under Maintenance",
    description: "We are currently improving our services. \nPlease check back soon.",
    button: "Back to home"
  },
  pt: {
    title: "Em Manutenção",
    description: "Estamos a melhorar os nossos serviços. \nPor favor, volte em breve.",
    button: "Voltar ao início"
  }
};

export default function Maintenance() {
  const { language } = useLanguage();
  const t = TRANSLATIONS[language];

  return (
    // O que mudou: Substituímos "min-h-screen" por "min-h-[85vh]" e adicionámos "py-24"
    <div className="relative flex flex-col items-center justify-center min-h-[85vh] py-24 bg-[#0A0A0A] text-white px-6 text-center w-[100vw] ml-[calc(50%-50vw)] overflow-hidden">
      
      {/* IMAGEM DE FUNDO */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_solar-scada-monitor/artifacts/q0jcs6xp_PV%20Plant%202.jpg" 
          alt="Background"
          className="w-full h-full object-cover blur-[6px] opacity-95 scale-105"
          decoding="async"
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>
      
      {/* CONTEÚDO */}
      <motion.div
        className="relative z-[2] max-w-2xl" 
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        {/* Ícone de Manutenção */}
        <div className="text-[#F68A31] mb-8">
           <svg xmlns="http://www.w3.org/2000/svg" className="w-24 h-24 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
           </svg>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight">
          {t.title}
        </h1>
        
        <p className="mt-6 text-white/70 text-lg md:text-xl max-w-lg mx-auto whitespace-pre-line">
          {t.description}
        </p>
        
        <Link 
          to="/" 
          className="btn-primary mt-10 inline-flex items-center justify-center px-8 py-3 font-medium text-black transition-transform hover:scale-105"
        >
          {t.button}
        </Link>
      </motion.div>
    </div>
  );
}